import { render, staticRenderFns } from "./OfficialHolidaysPlanEdit.vue?vue&type=template&id=3723735a&scoped=true&"
import script from "./OfficialHolidaysPlanEdit.vue?vue&type=script&lang=js&"
export * from "./OfficialHolidaysPlanEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3723735a",
  null
  
)

export default component.exports